var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
export class APINativeApp {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get present() {
        return this.parent;
    }
    get app() {
        return this.present.app;
    }
    sendReadyEventToWebView() {
        const data = JSON.stringify({
            answerId: this.app.answer.id,
            questionId: this.app.answer.question_id,
        });
        if (this.app.appInfo.isWebViewInIOSApp) {
            try {
                console.log('send ready event to app');
                webkit.messageHandlers.readyHandler.postMessage(data);
            }
            catch (err) {
                console.log('The native context does not exist yet');
            }
            return;
        }
        if (this.app.appInfo.isWebViewInAndroidApp) {
            try {
                console.log('send ready event to app');
                APP.ready(data);
            }
            catch (err) {
                console.log('failed to send ready event to app');
            }
            return;
        }
    }
    sendCompletedEventToWebView() {
        const data = JSON.stringify({
            answerId: this.app.answer.id,
            points: Math.ceil(this.app.answer.points),
            maxPoints: Math.ceil(this.app.answer.maxPoints),
            evaltext: this.app.answer.evaltext,
        });
        if (this.app.appInfo.isWebViewInIOSApp) {
            try {
                console.log('send completed event to app');
                webkit.messageHandlers.completedHandler.postMessage(data);
            }
            catch (err) {
                console.log('The native context does not exist yet');
            }
            return;
        }
        if (this.app.appInfo.isWebViewInAndroidApp) {
            try {
                console.log('send completed event to app');
                APP.completed(data);
            }
            catch (err) {
                console.log('failed to send completed event to app');
            }
            return;
        }
    }
    sendFinishedEventToWebView() {
        const data = JSON.stringify({
            answerId: this.app.answer.id,
            points: Math.ceil(this.app.answer.points),
            maxPoints: Math.ceil(this.app.answer.maxPoints),
            evaltext: this.app.answer.evaltext,
        });
        if (this.app.appInfo.isWebViewInIOSApp) {
            try {
                console.log('send finished event to app');
                webkit.messageHandlers.finishedHandler.postMessage(data);
            }
            catch (err) {
                console.log('The native context does not exist yet');
            }
            return;
        }
        if (this.app.appInfo.isWebViewInAndroidApp) {
            try {
                console.log('send finished event to app');
                APP.finished(data);
            }
            catch (err) {
                console.log('failed to send finished event to app');
            }
            return;
        }
    }
}
__decorate([
    action.bound
], APINativeApp.prototype, "sendReadyEventToWebView", null);
__decorate([
    action.bound
], APINativeApp.prototype, "sendCompletedEventToWebView", null);
__decorate([
    action.bound
], APINativeApp.prototype, "sendFinishedEventToWebView", null);
